<template>
  <div
    :class="[
      'editor-check-container',
      { 'jgsd-editor-check-container': isCanAlterCheck }
    ]"
  >
    <el-button @click="startCheckContent">
      <i class="icon jlxk-editor-check" />智能审校
    </el-button>
    <span
      class="check-total"
      v-show="isStartCheck"
    >提示内容共：<em>{{ total }}</em> 条</span>
    <p v-show="!isStartCheck">
      点击【智能审校】按钮开始校对
    </p>
    <el-table
      v-show="isStartCheck"
      ref="commonTable"
      :empty-text="empty"
      :data="tableData"
      border
      :cell-style="{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }"
    >
      <el-table-column
        v-for="(item, index) in thead"
        :key="index"
        :prop="tpropty[index]"
        align="center"
        :resizable="false"
        :label="item.label || item"
        :width="item.width"
      >
        <template slot-scope="scope">
          <span
            v-show="!scope.row.edit"
            :title="scope.row[tpropty[index]]"
            @click="handleRowClick(scope.row)"
            :class="{'manual':isStartCheck&&
              String(scope.row.offset) === '0' &&
              String(scope.row.paragraphIndex) === '0'}"
          >{{
            tpropty[index] === "index"
              ? scope.$index + 1
              : scope.row[tpropty[index]]
          }}</span>
          <div v-show="scope.row.edit">
            <span v-if="tpropty[index] === 'index'">{{
              scope.$index + 1
            }}</span>
            <span
              v-else-if="tpropty[index] === 'type'"
            ><el-select v-model="scope.row.type">
              <el-option
                v-for="(i, inspectIndex) in inspectTypeArr"
                :key="inspectIndex"
                :value="i.name"
                :label="i.name"
              /></el-select></span>
            <span v-else><el-input v-model="scope.row[tpropty[index]]" /></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="isCanAlterCheck"
        width="35"
        class-name="btn-delete"
      >
        <template slot-scope="scope">
          <i
            class="icon icon-jgsd-check-del"
            @click="deleteRow(scope.$index, tableData)"
          />
        </template>
      </el-table-column>
    </el-table>
    <el-button
      class="btn-add-check"
      v-show="isStartCheck && isCanAlterCheck"
      @click="addCheckContent"
    >
      添加类别
    </el-button>
  </div>
</template>

<script>
import { inspectTypeArr } from '@views/jgsd/report/data/type.js'
export default {
  name: 'TextAndFilm',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    empty: {
      type: String,
      default: ' '
    }
  },
  data() {
    return {
      isStartCheck: false,
      type: '敏感词检查',
      thead: [
        {
          width: 50,
          label: ' '
        },
        '类别',
        '提示词',
        '建议词'
      ],
      tpropty: ['index', 'type', 'checkedWord', 'suggestedWord'],
      inspectTypeArr: inspectTypeArr
    }
  },
  computed: {
    total() {
      return this.tableData.length
    },
    isCanAlterCheck() {
      return this.$route.query.check
    },
    checkData() {
      if (this.tableData.length === 0) return []
      return this.tableData.map(item => {
        return {
          classId: item.class_id,
          inspectCategory: item.inspectCategory,
          inspectType: item.type,
          offset: String(item.offset),
          suggestedWord: item.suggestedWord,
          paragraphIndex: item.paragraphIndex,
          detail: item.detail,
          pickedWord: item.checkedWord,
          initOffset: item.initOffset ? String(item.initOffset) : String(item.offset)
        }
      })
    }
  },
  created() {},
  mounted() {},
  methods: {
    startCheckContent() {
      this.$emit('startCheckContent')
    },
    handleRowClick(value) {
      this.$emit('handleRowClick', value)
    },
    // 删除行
    deleteRow(index, rows) {
      let delObj = rows[index]
      rows.splice(index, 1)
      // 手工增加的不进行标注不更新编辑器
      if (delObj.offset === 0 && delObj.paragraphIndex === 0) return false
      this.$emit('deleteRow', this.tableData)
    },
    addCheckContent() {
      this.tableData.push({
        edit: true,
        type: '敏感词检查',
        inspectCategory: '错误',
        class_id: `${this.tableData.length + 1}`,
        checkedWord: '',
        suggestedWord: '',
        paragraphIndex: 0,
        offset: 0,
        detail: ''
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.editor-check-container {
  margin: 0 20px;
  padding: 16px;
  background: #f5f5f5;
  /deep/ .el-button {
    width: 135px;
    height: 28px;
    padding: 0;
    line-height: 28px;
    background: rgba(68, 151, 236, 0.2);
    border-radius: 3px;
    font-size: 13px;
    font-family: "founder_youhei_508R";
    color: #4497ec;
    i {
      margin: -2px 15px 0 0;
    }
  }
  p {
    margin-top: 9px;
    font-size: 12px;
    color: #a9a9a9;
  }
  .check-total {
    margin-left: 10px;
    font-size: 12px;
    color: #666;
    em {
      color: #4497ec;
      font-style: normal;
    }
  }
  .btn-add-check {
    margin-top: 7px;
    width: auto;
    text-decoration: underline;
    color: #454647;
    border: none;
    background-color: transparent;
  }
  /deep/ .el-table {
    margin-top: 10px;
    border-color: #dcdcdc;
    &__body {
      width: 366px !important;
      &-wrapper {
        max-height: calc(100vh - 322px);
        overflow-y: auto;
      }
    }
    th,
    td {
      height: 32px;
      padding: 0;
      background: #fff;
      border-color: #dcdcdc;
      font-weight: normal;
      font-family: "founder_youhei_508R";
      .cell {
        padding: 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0 5px;
      }
    }
    th {
      color: #333;
      font-size: 13px;
    }
    tr {
      td {
        color: #454647;
        &:nth-child(3) {
          color: #e30e0e;
          cursor: pointer;
        }
        &:nth-child(4) {
          color: #4497ec;
        }
      }
    }
    .btn-delete {
      border: none;
      background-color: #f5f5f5;
      cursor: pointer;
    }
  }
  &.jgsd-editor-check-container {
    padding: 11px 15px;
    /deep/ .el-table {
      background-color: transparent;
      border-top: none;
      &::before,
      &::after {
        display: none;
      }
      &__empty-block {
        width: 334px !important;
        background-color: #fff;
        border: 1px solid #dcdcdc;
        border-width: 0 1px 1px 0;
      }
      th {
        border-top: 1px solid #dcdcdc;
        &.btn-delete {
          border-top: 1px solid #f5f5f5;
        }
      }
      tr {
        .manual{
          color: #454647;
        }
      }
    }
    /deep/ .el-select {
      .el-input {
        &__inner {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 12px 0 0;
          border: none;
          text-align: center;
        }
        &__suffix {
          right: -5px;
        }
      }
    }
    /deep/ .el-input {
      &__inner {
        background-color: #fff;
        padding: 0 5px;
        height: 20px;
        font-family: "founder_youhei_508R";
      }
    }
  }
}
</style>
